import { SVGProps, useContext, useEffect, useState } from 'react'
import { motion } from 'motion/react'
import { DarkModeContext } from '@repo/ui'
import { toZonedTime } from 'date-fns-tz'

const TIME_ZONE = 'Europe/Berlin'

const getHourRotation = () => {
  const zonedDate = toZonedTime(new Date(), TIME_ZONE)
  return (zonedDate.getHours() / 12) * 360 + (zonedDate.getMinutes() / 60) * 30
}
const getMinutesRotation = () => {
  const zonedDate = toZonedTime(new Date(), TIME_ZONE)
  return (zonedDate.getMinutes() / 60) * 360
}
const getSecondsRotation = () => {
  const zonedDate = toZonedTime(new Date(), TIME_ZONE)
  return (zonedDate.getSeconds() / 60) * 360 + 90 // +90 kommt von Position des Sekundenzeigers auf 9 Uhr in svg nicht 12.
}

function SvgComponent({ ...props }: Readonly<SVGProps<SVGSVGElement>>) {
  const [rotation, setRotation] = useState(getMinutesRotation)
  const { darkMode } = useContext(DarkModeContext)

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date()
      if (now.getSeconds() === 0) {
        setRotation(() => rotation + 6)
      }
    }, 1000)
    return () => clearInterval(interval)
  }, [rotation])

  return (
    <svg
      viewBox="0 0 376.57759 138.06925"
      id="svg1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs id="defs1" />
      <motion.g id="layer1" transform="translate(-11.070125,-3.3675962)">
        <motion.path
          initial={{ opacity: 0 }}
          animate={
            darkMode
              ? {
                  opacity: 1
                }
              : { opacity: 0 }
          }
          transition={{
            duration: 2,
            ease: 'easeIn'
          }}
          id="rect1698-8"
          style={{
            fill: '#fff876',
            fillOpacity: 0.46453,
            strokeWidth: 0.264583
          }}
          d="m 225.99396,16.338021 -24.67549,97.134639 c -0.1366,0.6067 0.59708,1.74318 1.49654,1.91771 11.54391,2.23996 20.7552,2.47892 31.27303,2.47892 10.51784,0 18.70724,-0.0932 31.45958,-3.2737 0.3017,-0.0752 1.12293,-1.12293 1.12293,-1.12293 L 239.92903,16.338021 Z"
        />
        <rect
          style={{
            fill: '#878c96',
            fillOpacity: 1,
            strokeWidth: 0.240529
          }}
          id="rect1626"
          width={374.17331}
          height={17.212158}
          x={12.05287}
          y={120.10902}
        />
        <rect
          style={{
            fill: '#bcbbb2',
            fillOpacity: 1,
            strokeWidth: 0.137365
          }}
          id="rect1626-1"
          width={374.23944}
          height={5.6126609}
          x={11.930311}
          y={114.61131}
        />
        <g
          id="g41"
          style={{
            fill: '#9c9a8e',
            fillOpacity: 1
          }}
          transform="translate(-655.92026,15.734759)"
        >
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41"
            width={9.5812531}
            height={2.9465408}
            x={794.7948}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-6"
            width={9.5812531}
            height={2.9465408}
            x={812.8371}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-1"
            width={9.5812531}
            height={2.9465408}
            x={830.87939}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-8"
            width={9.5812531}
            height={2.9465408}
            x={848.92169}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-4"
            width={9.5812531}
            height={2.9465408}
            x={866.96399}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-7"
            width={9.5812531}
            height={2.9465408}
            x={885.00629}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-0"
            width={9.5812531}
            height={2.9465408}
            x={903.04858}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-2"
            width={9.5812531}
            height={2.9465408}
            x={921.09088}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-23"
            width={9.5812531}
            height={2.9465408}
            x={939.13318}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-89"
            width={9.5812531}
            height={2.9465408}
            x={957.17554}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-77"
            width={9.5812531}
            height={2.9465408}
            x={975.21783}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-61"
            width={9.5812531}
            height={2.9465408}
            x={993.26013}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-79"
            width={9.5812531}
            height={2.9465408}
            x={1011.3024}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-20"
            width={9.5812531}
            height={2.9465408}
            x={1029.3447}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-2-1"
            width={9.5812531}
            height={2.9465408}
            x={668.49866}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-23-8"
            width={9.5812531}
            height={2.9465408}
            x={686.54095}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-89-4"
            width={9.5812531}
            height={2.9465408}
            x={704.58325}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-77-9"
            width={9.5812531}
            height={2.9465408}
            x={722.62555}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-61-1"
            width={9.5812531}
            height={2.9465408}
            x={740.66785}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-79-0"
            width={9.5812531}
            height={2.9465408}
            x={758.71014}
            y={122.04446}
            ry={0.85477704}
          />
          <rect
            style={{
              fill: '#9c9a8e',
              fillOpacity: 1,
              strokeWidth: 0.202111
            }}
            id="rect41-20-6"
            width={9.5812531}
            height={2.9465408}
            x={776.75244}
            y={122.04446}
            ry={0.85477704}
          />
        </g>
        <rect
          style={{
            fill: '#747067',
            fillOpacity: 1,
            strokeWidth: 0.31394
          }}
          id="rect1"
          width={373.99112}
          height={2.89291}
          x={12.282362}
          y={135.24081}
        />
        <g id="g1684" transform="translate(-516.36472,-26.727976)">
          <path
            id="rect1627-4"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0956479
            }}
            d="m 691.08547,101.02794 c -3.78631,0 -6.83421,3.0479 -6.83421,6.83421 v 6.26215 5.13922 7.4967 c 0,0.25615 0.20584,0.46199 0.46198,0.46199 h 22.85132 c 0.25615,0 0.46251,-0.20584 0.46251,-0.46199 v -7.4967 -5.13922 -6.26215 c 0,-3.78631 -3.04842,-6.83421 -6.83473,-6.83421 z"
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.124237
            }}
            id="rect1628"
            width={23.760265}
            height={6.3610144}
            x={684.25885}
            y={124.60105}
            ry={2.2111673}
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.3186
            }}
            id="rect1629"
            width={5.4255714}
            height={12.722029}
            x={693.42615}
            y={128.9041}
            ry={0.85477686}
          />
        </g>
        <g id="g1684-7" transform="translate(-489.89012,-26.727976)">
          <path
            id="rect1627-4-9"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0956479
            }}
            d="m 691.08547,101.02794 c -3.78631,0 -6.83421,3.0479 -6.83421,6.83421 v 6.26215 5.13922 7.4967 c 0,0.25615 0.20584,0.46199 0.46198,0.46199 h 22.85132 c 0.25615,0 0.46251,-0.20584 0.46251,-0.46199 v -7.4967 -5.13922 -6.26215 c 0,-3.78631 -3.04842,-6.83421 -6.83473,-6.83421 z"
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.124237
            }}
            id="rect1628-0"
            width={23.760265}
            height={6.3610144}
            x={684.25885}
            y={124.60105}
            ry={2.2111673}
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.3186
            }}
            id="rect1629-4"
            width={5.4255714}
            height={12.722029}
            x={693.42615}
            y={128.9041}
            ry={0.85477686}
          />
        </g>
        <g id="g1684-1" transform="translate(-463.41552,-26.727976)">
          <path
            id="rect1627-4-7"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0956479
            }}
            d="m 691.08547,101.02794 c -3.78631,0 -6.83421,3.0479 -6.83421,6.83421 v 6.26215 5.13922 7.4967 c 0,0.25615 0.20584,0.46199 0.46198,0.46199 h 22.85132 c 0.25615,0 0.46251,-0.20584 0.46251,-0.46199 v -7.4967 -5.13922 -6.26215 c 0,-3.78631 -3.04842,-6.83421 -6.83473,-6.83421 z"
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.124237
            }}
            id="rect1628-1"
            width={23.760265}
            height={6.3610144}
            x={684.25885}
            y={124.60105}
            ry={2.2111673}
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.3186
            }}
            id="rect1629-1"
            width={5.4255714}
            height={12.722029}
            x={693.42615}
            y={128.9041}
            ry={0.85477686}
          />
        </g>
        <g id="g1684-6" transform="translate(-436.94091,-26.727976)">
          <path
            id="rect1627-4-8"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0956479
            }}
            d="m 691.08547,101.02794 c -3.78631,0 -6.83421,3.0479 -6.83421,6.83421 v 6.26215 5.13922 7.4967 c 0,0.25615 0.20584,0.46199 0.46198,0.46199 h 22.85132 c 0.25615,0 0.46251,-0.20584 0.46251,-0.46199 v -7.4967 -5.13922 -6.26215 c 0,-3.78631 -3.04842,-6.83421 -6.83473,-6.83421 z"
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.124237
            }}
            id="rect1628-9"
            width={23.760265}
            height={6.3610144}
            x={684.25885}
            y={124.60105}
            ry={2.2111673}
          />
          <rect
            style={{
              fill: '#959485',
              fillOpacity: 1,
              strokeWidth: 0.3186
            }}
            id="rect1629-3"
            width={5.4255714}
            height={12.722029}
            x={693.42615}
            y={128.9041}
            ry={0.85477686}
          />
        </g>
        <ellipse
          style={{
            fill: '#fce3b4',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.278548
          }}
          id="path1694"
          cx={233.06485}
          cy={67.960541}
          rx={6.9122396}
          ry={9.0907545}
        />
        <rect
          style={{
            fill: '#282d37',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.277054
          }}
          id="rect1689"
          width={7.4083333}
          height={16.536459}
          x={220.13333}
          y={97.498962}
        />
        <rect
          style={{
            fill: '#282d37',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.335066
          }}
          id="rect1689-5"
          width={7.4110651}
          height={24.177641}
          x={-99.266182}
          y={218.60081}
          transform="matrix(-0.01589109,-0.99987373,0.99998595,0.00530051,0,0)"
          ry={3.3214641}
        />
        <rect
          style={{
            fill: '#282d37',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.310889
          }}
          id="rect1689-5-8"
          width={7.4108186}
          height={20.815144}
          x={-89.701103}
          y={222.62238}
          transform="matrix(0.00722041,-0.99997393,0.99963896,0.02686894,0,0)"
          ry={0}
        />
        <rect
          style={{
            fill: '#282d37',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.275387
          }}
          id="rect1689-0"
          width={7.4083333}
          height={16.33802}
          x={236.80208}
          y={97.432823}
        />
        <rect
          style={{
            fill: '#131821',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.235546
          }}
          id="rect1690"
          width={9.8557291}
          height={6.0854168}
          x={218.47968}
          y={108.74375}
          ry={2.1166666}
        />
        <rect
          style={{
            fill: '#131821',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.235546
          }}
          id="rect1690-2"
          width={9.8557291}
          height={6.0854168}
          x={235.80989}
          y={108.61146}
          ry={2.1166666}
        />
        <g id="g1697">
          <rect
            style={{
              fill: '#131821',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1693"
            width={5.1593747}
            height={3.7703125}
            x={227.21094}
            y={65.256882}
            ry={0.92604166}
          />
          <rect
            style={{
              fill: '#3c414b',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.204239
            }}
            id="rect1693-0"
            width={3.9826753}
            height={2.9104168}
            x={227.79929}
            y={65.686829}
            ry={0.71483916}
          />
          <rect
            style={{
              fill: '#131821',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1693-5"
            width={5.1593747}
            height={3.7703125}
            x={233.29922}
            y={65.256882}
            ry={0.92604166}
          />
          <rect
            style={{
              fill: '#3c414b',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.204239
            }}
            id="rect1693-0-7"
            width={3.9826753}
            height={2.9104168}
            x={233.88757}
            y={65.686829}
            ry={0.71483916}
          />
          <rect
            style={{
              fill: '#131821',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1695"
            width={1.7071841}
            height={0.65481037}
            x={231.94318}
            y={65.317329}
            ry={0.32740518}
          />
          <rect
            style={{
              fill: '#131821',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.326626
            }}
            id="rect1695-0"
            width={2.0813615}
            height={0.81851298}
            x={237.94022}
            y={65.32869}
            ry={0.40925649}
          />
          <rect
            style={{
              fill: '#131821',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.291733
            }}
            id="rect1695-0-1"
            width={1.6604121}
            height={0.81851298}
            x={226.21414}
            y={65.235153}
            ry={0.40925649}
          />
        </g>
        <path
          id="rect1686"
          style={{
            fill: '#131821',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.264583
          }}
          d="m 229.9379,51.544141 c -2.28023,0 -4.11603,1.835791 -4.11603,4.116027 v 1.028361 3.901054 h -2.79156 c -0.72553,0 -1.30948,0.583951 -1.30948,1.309481 v 1.614372 c 0,0.72553 0.58395,1.309481 1.30948,1.309481 h 20.39979 c 0.72553,0 1.30948,-0.583951 1.30948,-1.309481 v -1.614372 c 0,-0.72553 -0.58395,-1.309481 -1.30948,-1.309481 h -2.79156 v -4.349088 -0.580327 c 0,-2.280236 -1.83579,-4.116027 -4.11603,-4.116027 z"
        />
        <motion.g
          id="g1696"
          animate={{ y: [-7, 0, -7, -7] }}
          transition={{
            times: [0, 0.1, 0.11, 1],
            duration: 20,
            type: 'keyframes',
            ease: 'easeOut',
            repeat: Infinity
          }}
          transform="translate(0.28258015,-6.9294012)"
        >
          <path
            id="rect1688"
            style={{
              fill: '#ddded6',
              fillOpacity: 1,
              strokeWidth: 0.264583
            }}
            d="m 461.7972,66.102328 c 0,0 1.23354,10.627504 1.85208,15.610417 0.61854,4.982914 1.85208,14.2875 1.85208,14.2875 l 21.03438,5.820835 23.41562,-4.497919 c 0,0 -0.22367,-10.411753 0,-15.610416 0.22069,-5.129504 1.32292,-15.345834 1.32292,-15.345834 l -23.94479,3.704167 z m 21.7289,7.077604 a 1.0914062,0.9921875 0 0 1 1.09141,0.992188 1.0914062,0.9921875 0 0 1 -1.09141,0.992187 1.0914062,0.9921875 0 0 1 -1.0914,-0.992187 1.0914062,0.9921875 0 0 1 1.0914,-0.992188 z m 6.81302,0 a 1.0252604,1.0583333 0 0 1 1.02526,1.058333 1.0252604,1.0583333 0 0 1 -1.02526,1.058334 1.0252604,1.0583333 0 0 1 -1.02526,-1.058334 1.0252604,1.0583333 0 0 1 1.02526,-1.058333 z"
            transform="translate(-254.09928,0.3080888)"
          />
          <path
            id="rect1691"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.264583
            }}
            d="m 196.51651,152.65941 16.30656,2.42755 c 0,0 -0.63622,1.27829 -0.99679,2.09388 -0.47413,1.0725 -0.80741,1.93254 -0.80741,1.93254 l -16.52757,-1.2918 z"
            transform="rotate(-20.719951)"
          />
          <path
            id="rect1691-5"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.241708
            }}
            d="m 209.91122,69.156502 c 0,0 0.40099,1.576886 0.45785,2.213302 0.0747,0.836884 0.0832,1.496033 0.0832,1.496033 l 18.58388,3.315559 -0.0155,-0.782897 a 1.0914062,0.9921875 0 0 1 -0.68523,-0.918291 1.0914062,0.9921875 0 0 1 0.64854,-0.905888 l -0.0274,-1.355989 z"
          />
          <path
            id="rect1691-5-0"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0872316
            }}
            d="m 218.392,75.982766 -7.38416,-0.998842 c 0,0 0.0201,0.189307 0.0429,0.395893 0.03,0.27166 0.0335,0.485653 0.0335,0.485653 l 7.45647,1.076362 z"
          />
          <path
            id="rect1691-5-0-3"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0872316
            }}
            d="m 218.64868,77.689949 -7.38416,-0.998842 c 0,0 0.0201,0.189307 0.0429,0.395893 0.03,0.27166 0.0335,0.485653 0.0335,0.485653 l 7.32418,1.076362 z"
          />
          <path
            id="rect1691-5-0-6"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0872316
            }}
            d="m 218.63105,79.36317 -7.2684,-0.982306 c 0,0 0.0201,0.189307 0.0429,0.395893 0.03,0.27166 0.0335,0.485653 0.0335,0.485653 2.43588,0.353275 3.27974,0.457749 7.20842,1.059826 z"
          />
          <path
            id="rect1691-5-0-0"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.0872316
            }}
            d="m 218.6065,80.936484 -6.91644,-0.998842 c 0,0 0.0201,0.189307 0.0429,0.395893 0.03,0.27166 0.0335,0.485653 0.0335,0.485653 l 6.92025,1.15337 z"
          />
          <path
            id="rect1691-5-0-39"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.252292
            }}
            d="m 228.85509,78.557593 -8.69378,-2.08774 c 0,0 0.3475,4.062459 0.3703,5.790529 0.03,2.272408 0.54135,9.599884 0.54135,9.599884 l 8.44533,2.437224 z"
          />
          <path
            id="rect1691-5-0-39-2"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.252292
            }}
            d="m 244.47588,92.954867 8.4151,-2.464838 c -0.0511,2.459016 -0.12802,3.279428 0.11069,5.414242 l -8.588,2.350327 z"
          />
          <path
            id="rect1691-5-0-39-2-3"
            style={{
              fill: '#bcbbb2',
              fillOpacity: 1,
              strokeWidth: 0.252292
            }}
            d="m 234.72963,89.166114 8.32156,-1.716483 c -0.0511,2.459016 0.10583,2.343984 0.20423,4.665887 l -8.588,2.350327 z"
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692"
            width={1.984375}
            height={2.1166666}
            x={207.96249}
            y={76.861458}
            ry={0.9921875}
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-7"
            width={1.984375}
            height={2.1166666}
            x={208.10832}
            y={78.721573}
            ry={0.9921875}
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-3"
            width={1.984375}
            height={2.1166666}
            x={208.24174}
            y={80.623177}
            ry={0.9921875}
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-1"
            width={1.984375}
            height={2.1166666}
            x={208.8819}
            y={82.396385}
            ry={0.9921875}
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-9"
            width={1.984375}
            height={2.1166666}
            x={-249.99127}
            y={96.69648}
            ry={0.9921875}
            transform="matrix(-0.99667257,0.08150941,0.08150941,0.99667257,0,0)"
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-7-2"
            width={1.984375}
            height={2.1166666}
            x={-249.84546}
            y={98.556595}
            ry={0.9921875}
            transform="matrix(-0.99667257,0.08150941,0.08150941,0.99667257,0,0)"
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-3-8"
            width={1.984375}
            height={2.1166666}
            x={-249.71204}
            y={100.4582}
            ry={0.9921875}
            transform="matrix(-0.99667257,0.08150941,0.08150941,0.99667257,0,0)"
          />
          <rect
            style={{
              fill: '#fce3b4',
              fillOpacity: 1,
              fillRule: 'nonzero',
              strokeWidth: 0.264583
            }}
            id="rect1692-1-4"
            width={1.984375}
            height={2.1166666}
            x={-249.07187}
            y={102.23141}
            ry={0.9921875}
            transform="matrix(-0.99667257,0.08150941,0.08150941,0.99667257,0,0)"
          />
        </motion.g>
        <motion.path
          initial={{ opacity: 0 }}
          animate={
            darkMode
              ? {
                  opacity: 1
                }
              : { opacity: 0 }
          }
          transition={{
            duration: 2,
            ease: 'easeIn'
          }}
          id="rect1699"
          style={{
            fill: '#878c96',
            fillOpacity: 1,
            fillRule: 'nonzero',
            strokeWidth: 0.264583
          }}
          d="m 231.24583,4.6963542 c -3.04151,0 -5.4901,2.4485864 -5.4901,5.4901038 0,0.3392 0.0321,0.670311 0.0904,0.992188 h -0.15864 c -1.2082,0 -2.18075,0.972546 -2.18075,2.180745 v 0.797884 c 0,1.2082 0.97255,2.180746 2.18075,2.180746 h 14.42392 c 1.2082,0 2.18075,-0.972546 2.18075,-2.180746 v -0.797884 c 0,-1.128185 -0.84855,-2.050029 -1.94459,-2.167309 0.0599,-0.326054 0.0925,-0.661727 0.0925,-1.005624 0,-3.0415174 -2.44858,-5.4901038 -5.4901,-5.4901038 z"
        />
        <motion.path
          initial={{ opacity: 0 }}
          animate={
            darkMode
              ? {
                  opacity: 1
                }
              : { opacity: 0 }
          }
          transition={{
            duration: 2,
            ease: 'easeIn'
          }}
          id="path1700"
          style={{
            fill: '#fff876',
            fillOpacity: 0.46453,
            strokeWidth: 0.264583
          }}
          d="m 225.99396,16.338021 -24.67549,97.134639 c -0.1366,0.6067 0.59708,1.74318 1.49654,1.91771 11.54391,2.23996 20.7552,2.47892 31.27303,2.47892 10.51784,0 18.70724,-0.0932 31.45958,-3.2737 0.3017,-0.0752 1.12293,-1.12293 1.12293,-1.12293 L 239.92903,16.338021 Z"
        />
      </motion.g>
      <path
        id="rect1621"
        style={{
          fill: '#878c96',
          fillOpacity: 1,
          strokeWidth: 0.264583
        }}
        d="m 108.83926,6.8752018 c -1.86888,0 -3.37344,1.504553 -3.37344,3.3734372 0,1.682606 1.21968,3.069162 2.8267,3.328996 v 3.842142 h -8.916255 v 3.485058 h 8.916255 v 6.534485 h -8.916255 v 3.485059 h 8.916255 v 80.422481 h 7.40834 V 30.924379 H 129.0096 V 27.43932 H 115.70086 V 20.904835 H 129.0096 V 17.419777 H 115.70086 V 13.53216 c 1.49211,-0.34896 2.59725,-1.682058 2.59725,-3.283521 0,-1.8688842 -1.50455,-3.3734372 -3.37343,-3.3734372 z"
      />
      <g id="g1692" transform="translate(-11.070125,-3.3675962)">
        <g
          id="g1616"
          transform="matrix(1.3238496,0,0,1.2265912,-130.64553,-21.864023)"
        >
          <ellipse
            style={{
              fill: '#0a1e6e',
              fillOpacity: 1,
              strokeWidth: 0.207691
            }}
            id="path1258-9"
            cx={216.49384}
            cy={39.946419}
            rx={15.111783}
            ry={16.31002}
          />
          <ellipse
            style={{
              fill: '#f0f3f5',
              fillOpacity: 1,
              strokeWidth: 0.18881
            }}
            id="path1258"
            cx={216.49384}
            cy={39.946419}
            rx={13.737985}
            ry={14.827291}
          />
          <rect
            style={{
              fill: '#0a1e6e',
              fillOpacity: 1,
              strokeWidth: 0.251747
            }}
            id="rect1258"
            width={0.89154822}
            height={3.6084018}
            x={216.04807}
            y={24.877392}
          />
          <use x={0} y={0} xlinkHref="#rect1258" id="use1368" />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            id="use1368-9"
            transform="matrix(0.35191643,0,0,0.35191643,140.30609,16.675107)"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(0.8660254,0.53964581,-0.46326683,0.8660254,47.555658,-111.43934)"
            id="use1369"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(0.5,0.93469395,-0.80240168,0.5,140.36621,-182.28543)"
            id="use1370"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(0,1.0792916,-0.92653365,0,253.56316,-193.55513)"
            id="use1371"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(-0.5,0.93469395,-0.80240168,-0.5,356.81547,-142.2287)"
            id="use1372"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(-0.8660254,0.53964581,-0.46326683,-0.8660254,422.45676,-42.059049)"
            id="use1373"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="rotate(180,216.44926,40.056734)"
            id="use1374"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(-0.8660254,-0.53964581,0.46326683,-0.8660254,385.34285,191.55282)"
            id="use1375"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(-0.5,-0.93469395,0.80240168,-0.5,292.53229,262.39891)"
            id="use1376"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(0,-1.0792916,0.92653365,0,179.33534,273.6686)"
            id="use1377"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(0.5,-0.93469395,0.80240168,0.5,76.083037,222.34218)"
            id="use1378"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#rect1258"
            transform="matrix(0.8660254,-0.53964581,0.46326683,0.8660254,10.441746,122.17252)"
            id="use1379"
          />
          <use x={0} y={0} xlinkHref="#use1368-9" id="use1557" />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.9945219,0.11281669,-0.09684914,0.9945219,5.0711588,-24.206214)"
            id="use1558"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.9781476,0.22439734,-0.19263718,0.9781476,12.458888,-47.707713)"
            id="use1559"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.95105652,0.33351945,-0.28631464,0.95105652,22.082247,-70.247009)"
            id="use1560"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.91354546,0.43898745,-0.37685519,0.91354546,33.835799,-91.577156)"
            id="use1561"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.8660254,0.53964581,-0.46326683,0.8660254,47.590771,-111.46446)"
            id="use1562"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.80901699,0.63439169,-0.54460282,0.80901699,63.196459,-129.69103)"
            id="use1563"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.74314483,0.72218705,-0.61997203,0.74314483,80.481885,-146.05716)"
            id="use1564"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.66913061,0.80206998,-0.68854869,0.66913061,99.257666,-160.38356)"
            id="use1565"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.58778525,0.87316526,-0.74958147,0.58778525,119.31809,-172.51326)"
            id="use1566"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.5,0.93469395,-0.80240168,0.5,140.44337,-182.31335)"
            id="use1567"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.40673664,0.98598195,-0.84643061,0.40673664,162.40206,-189.67648)"
            id="use1568"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.30901699,1.0264673,-0.88118587,0.30901699,184.95357,-194.52196)"
            id="use1569"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.20791169,1.0557065,-0.90628667,0.20791169,207.85081,-196.79671)"
            id="use1570"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.10452846,1.0733791,-0.92145801,0.10452846,230.84294,-196.47581)"
            id="use1571"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0,1.0792916,-0.92653365,0,253.67803,-193.56278)"
            id="use1572"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.10452846,1.0733791,-0.92145801,-0.10452846,276.1059,-188.08952)"
            id="use1573"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.20791169,1.0557065,-0.90628667,-0.20791169,297.88083,-180.116)"
            id="use1574"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.30901699,1.0264673,-0.88118587,-0.30901699,318.76424,-169.72959)"
            id="use1575"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.40673664,0.98598195,-0.84643061,-0.40673664,338.52734,-157.04408)"
            id="use1576"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.5,0.93469395,-0.80240168,-0.5,356.9536,-142.19846)"
            id="use1577"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.58778525,0.87316526,-0.74958147,-0.58778525,373.84113,-125.35537)"
            id="use1578"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.66913061,0.80206998,-0.68854869,-0.66913061,389.0049,-106.69935)"
            id="use1579"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.74314483,0.72218705,-0.61997203,-0.74314483,402.27879,-86.434809)"
            id="use1580"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.80901699,0.63439169,-0.54460282,-0.80901699,413.51736,-64.783761)"
            id="use1581"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.8660254,0.53964581,-0.46326683,-0.8660254,422.59748,-41.983421)"
            id="use1582"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.91354546,0.43898745,-0.37685519,-0.91354546,429.41967,-18.283595)"
            id="use1583"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.95105652,0.33351945,-0.28631464,-0.95105652,433.90917,6.056057)"
            id="use1584"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.9781476,0.22439734,-0.19263718,-0.9781476,436.0168,30.768865)"
            id="use1585"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.9945219,0.11281669,-0.09684914,-0.9945219,435.71948,55.58407)"
            id="use1586"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="rotate(180,216.51023,40.114896)"
            id="use1587"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.9945219,-0.11281669,0.09684914,-0.9945219,427.94929,104.43601)"
            id="use1588"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.9781476,-0.22439734,0.19263718,-0.9781476,420.56156,127.9375)"
            id="use1589"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.95105652,-0.33351945,0.28631464,-0.95105652,410.93821,150.4768)"
            id="use1590"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.91354546,-0.43898745,0.37685519,-0.91354546,399.18465,171.80695)"
            id="use1591"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.8660254,-0.53964581,0.46326683,-0.8660254,385.42968,191.69425)"
            id="use1592"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.80901699,-0.63439169,0.54460282,-0.80901699,369.82399,209.92082)"
            id="use1593"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.74314483,-0.72218705,0.61997203,-0.74314483,352.53857,226.28695)"
            id="use1594"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.66913061,-0.80206998,0.68854869,-0.66913061,333.76279,240.61335)"
            id="use1595"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.58778525,-0.87316526,0.74958147,-0.58778525,313.70236,252.74305)"
            id="use1596"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.5,-0.93469395,0.80240168,-0.5,292.57708,262.54314)"
            id="use1597"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.40673664,-0.98598195,0.84643061,-0.40673664,270.61839,269.90627)"
            id="use1598"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.30901699,-1.0264673,0.88118587,-0.30901699,248.06689,274.75175)"
            id="use1599"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.20791169,-1.0557065,0.90628667,-0.20791169,225.16964,277.0265)"
            id="use1600"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(-0.10452846,-1.0733791,0.92145801,-0.10452846,202.17752,276.7056)"
            id="use1601"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0,-1.0792916,0.92653365,0,179.34243,273.79257)"
            id="use1602"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.10452846,-1.0733791,0.92145801,0.10452846,156.91455,268.31931)"
            id="use1603"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.20791169,-1.0557065,0.90628667,0.20791169,135.13962,260.34579)"
            id="use1604"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.30901699,-1.0264673,0.88118587,0.30901699,114.25621,249.95938)"
            id="use1605"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.40673664,-0.98598195,0.84643061,0.40673664,94.493108,237.27387)"
            id="use1606"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.5,-0.93469395,0.80240168,0.5,76.066853,222.42825)"
            id="use1607"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.58778525,-0.87316526,0.74958147,0.58778525,59.179326,205.58516)"
            id="use1608"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.66913061,-0.80206998,0.68854869,0.66913061,44.015548,186.92914)"
            id="use1609"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.74314483,-0.72218705,0.61997203,0.74314483,30.741659,166.6646)"
            id="use1610"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.80901699,-0.63439169,0.54460282,0.80901699,19.503089,145.01355)"
            id="use1611"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.8660254,-0.53964581,0.46326683,0.8660254,10.42297,122.21321)"
            id="use1612"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.91354546,-0.43898745,0.37685519,0.91354546,3.600786,98.513386)"
            id="use1613"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.95105652,-0.33351945,0.28631464,0.95105652,-0.88871736,74.173734)"
            id="use1614"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.9781476,-0.22439734,0.19263718,0.9781476,-2.9963524,49.460926)"
            id="use1615"
          />
          <use
            x={0}
            y={0}
            xlinkHref="#use1368-9"
            transform="matrix(0.9945219,-0.11281669,0.09684914,0.9945219,-2.6990274,24.645721)"
            id="use1616"
          />
        </g>
        <motion.rect
          initial={{
            rotateZ: getHourRotation()
          }}
          animate={{
            rotate: 360
          }}
          transition={{
            times: [0, 1],
            duration: 43200,
            repeat: Infinity,
            type: 'keyframes',
            ease: 'linear'
          }}
          style={{
            originY: 1,
            fill: '#0a1e6e',
            fillOpacity: 1,
            strokeWidth: 0.344237
          }}
          id="rect1616"
          width={1.8445939}
          height={10.71218}
          x={155.03745}
          y={16.422777}
        />
        <motion.rect
          initial={{
            rotateZ: rotation
          }}
          animate={{
            rotateZ: rotation
          }}
          transition={{
            duration: 1,
            repeat: 0,
            ease: 'linear',
            type: 'spring',
            stiffness: 300,
            damping: 10
          }}
          style={{
            originY: 1,
            fill: '#0a1e6e',
            fillOpacity: 1,
            strokeWidth: 0.439437
          }}
          id="rect1616-5"
          width={1.8445939}
          height={17.456455}
          x={155.03745}
          y={9.6860027}
        />
        <motion.path
          id="path1617"
          initial={{
            rotateZ: getSecondsRotation()
          }}
          animate={{
            rotate: 360
          }}
          transition={{
            times: [0, 1],
            duration: 60,
            repeat: Infinity,
            type: 'keyframes',
            ease: 'linear'
          }}
          style={{
            originX: 1,
            fill: '#ec0016',
            fillOpacity: 1,
            strokeWidth: 0.3208
          }}
          d="m 145.35288,24.709086 a 2.4249368,2.4249368 0 0 0 -2.39726,2.063957 h -1.61748 v 0.72192 h 1.61696 a 2.4249368,2.4249368 0 0 0 2.39778,2.064473 2.4249368,2.4249368 0 0 0 2.39727,-2.064473 h 7.06107 v -0.1726 h 1.18184 v -0.429947 h -1.18184 v -0.119373 h -7.06107 a 2.4249368,2.4249368 0 0 0 -2.39727,-2.063957 z m 0,0.606682 a 1.8187026,1.8187026 0 0 1 1.8185,1.818493 1.8187026,1.8187026 0 0 1 -1.8185,1.818494 1.8187026,1.8187026 0 0 1 -1.81901,-1.818494 1.8187026,1.8187026 0 0 1 1.81901,-1.818493 z"
        />
        <circle
          style={{
            fill: '#0a1e6e',
            fillOpacity: 1,
            strokeWidth: 0.262167
          }}
          id="path1616"
          cx={155.95975}
          cy={27.133904}
          r={1.8187026}
        />
      </g>
      <g
        id="g40"
        transform="matrix(1.4833634,0,0,1.4833634,479.48142,13.19905)"
      >
        <path
          id="rect38"
          style={{
            fill: '#38342f',
            fillOpacity: 1,
            strokeWidth: 0.203111
          }}
          d="m -119.24443,60.372276 c -0.57464,-0.0032 -1.1225,0.32965 -1.36736,0.888836 -0.32648,0.74558 0.0135,1.60268 0.76223,1.921847 l 6.55567,2.794661 -1.21857,2.727982 -6.11642,-0.04186 c -0.36582,-0.0025 -0.66044,0.289948 -0.66095,0.655772 l -0.003,1.609206 c -5.1e-4,0.365824 0.29358,0.66206 0.6594,0.664559 l 4.81521,0.03307 -3.05772,6.8435 c -0.33101,0.740956 -0.001,1.604212 0.73949,1.935283 0.74093,0.331071 1.60421,9.22e-4 1.93528,-0.740006 l 5.60225,-12.538769 30.785199,13.123229 c 0.748742,0.319168 1.614481,-0.0244 1.940963,-0.769981 0.326481,-0.74558 -0.01348,-1.602676 -0.76222,-1.921843 l -40.036842,-17.06666 c -0.18718,-0.07979 -0.38155,-0.117804 -0.57309,-0.118856 z"
        />
        <rect
          style={{
            fill: '#4d0820',
            fillOpacity: 1,
            strokeWidth: 0.189452
          }}
          id="rect37"
          width={3.190311}
          height={14.009613}
          x={-121.84181}
          y={58.854965}
          ry={0.75674784}
        />
        <rect
          style={{
            fill: '#38342f',
            fillOpacity: 1,
            strokeWidth: 0.209618
          }}
          id="rect40"
          width={45.410603}
          height={2.1262381}
          x={-121.03191}
          y={78.772858}
          ry={0.66233343}
        />
        <path
          id="rect1625"
          style={{
            fill: '#4f4b41',
            fillOpacity: 1,
            strokeWidth: 0.178367
          }}
          d="m -112.07398,63.092949 c 0.60486,-0.243815 1.74704,0.290666 1.74704,0.290666 l 1.83622,0.781176 1.83622,0.781176 c 0,0 1.07961,0.310093 1.4126,0.892661 0.333,0.582568 -0.22453,1.92883 -0.22453,1.92883 0,0 -0.36961,0.920906 -0.96458,1.176376 -0.59494,0.255485 -1.73165,-0.375989 -1.73165,-0.375989 0,0 -0.96439,-0.320233 -1.54787,-0.07532 -0.58348,0.244907 -1.03899,1.058559 -1.03899,1.058559 0,0 -0.23971,0.902811 -0.8329,1.136271 -0.59319,0.233456 -1.13497,0.01432 -1.74704,-0.246076 -0.61207,-0.260392 -1.0796,-0.399271 -1.32341,-1.004134 -0.24382,-0.604867 0.23782,-1.541458 0.23782,-1.541458 l 0.75063,-1.764415 0.75063,-1.764415 c 0,0 0.23494,-1.030093 0.83981,-1.273904 z"
        />
        <path
          id="rect1625-4"
          style={{
            fill: '#4f4b41',
            fillOpacity: 1,
            strokeWidth: 0.178367
          }}
          d="m -76.455943,78.579992 c 0.21136,0.106241 0.84502,0.46887 0.84502,0.46887 l 0.0595,1.893034 -5.20702,-0.01479 c -1.39543,-0.01765 -2.61063,0.06422 -5.0619,-0.02611 -0.20074,-1.555159 -0.01,-1.804351 0.32483,-2.984777 0.33462,-1.180427 0.35657,-1.151885 0.68306,-1.731398 0.32649,-0.579512 0.36016,-0.716669 0.98828,-0.892079 0.62812,-0.17542 1.50569,0.429156 1.50569,0.429156 l 1.75975,0.829706 1.75975,0.851991 c 0,0 1.22315,0.596374 1.49026,0.752779 0.26711,0.156406 0.64141,0.317378 0.85278,0.423618 z"
        />
        <path
          id="rect1625-4-2"
          style={{
            fill: '#4f4b41',
            fillOpacity: 1,
            strokeWidth: 0.144869
          }}
          d="m -121.0561,78.974102 0.0123,1.92727 3.10383,9.76e-4 c 0.92053,-0.01765 2.63655,0.06422 4.3324,0.03695 0.13243,-1.555159 -0.22364,-2.229228 -0.5232,-3.110109 -0.29956,-0.880881 -0.40593,-1.418316 -0.6213,-1.997829 -0.21538,-0.579512 -0.71958,-0.950776 -1.13392,-1.126186 -0.41436,-0.17542 -1.31655,-0.217424 -1.52836,0.284234 l -0.56692,1.320215 -0.97444,1.661502 c 0,0 -0.75709,0.583941 -1.21892,0.684607 -0.46183,0.100666 -0.61034,0.178028 -0.88145,0.318368 z"
        />
      </g>
      <g id="g1620" transform="translate(-276.33659,-23.633939)">
        <rect
          style={{
            fill: '#0a1e6e',
            fillOpacity: 1,
            strokeWidth: 0.372595
          }}
          id="rect1257"
          width={43.473606}
          height={23.127958}
          x={333.70343}
          y={36.8946}
          ry={2.0579753}
        />
        <path
          style={{
            fill: '#f0f3f5'
          }}
          d="m 345.3375,43.536395 -4.3925,6.864357 h 4.3925 z m -0.45648,-1.515843 h 2.18764 v 8.3802 h 1.83451 v 1.446941 h -1.83451 v 3.031686 h -1.73116 v -3.031686 h -5.80499 v -1.679485 z m 10.61952,1.145495 q -1.34359,0 -2.024,1.326362 -0.67179,1.31775 -0.67179,3.970476 0,2.644112 0.67179,3.970475 0.68041,1.31775 2.024,1.31775 1.3522,0 2.02399,-1.31775 0.68041,-1.326363 0.68041,-3.970475 0,-2.652726 -0.68041,-3.970476 -0.67179,-1.326362 -2.02399,-1.326362 z m 0,-1.378039 q 2.1618,0 3.29868,1.713936 1.14549,1.705323 1.14549,4.960941 0,3.247004 -1.14549,4.96094 -1.13688,1.705324 -3.29868,1.705324 -2.1618,0 -3.3073,-1.705324 -1.13688,-1.713936 -1.13688,-4.96094 0,-3.255618 1.13688,-4.960941 1.1455,-1.713936 3.3073,-1.713936 z m 12.28177,1.748387 -4.3925,6.864357 h 4.3925 z m -0.45647,-1.515843 h 2.18763 v 8.3802 h 1.83452 v 1.446941 h -1.83452 v 3.031686 h -1.73116 v -3.031686 h -5.80499 v -1.679485 z"
          id="text1257"
        />
      </g>
      <motion.path
        initial={{ opacity: 0 }}
        animate={
          darkMode
            ? {
                opacity: 1
              }
            : { opacity: 0 }
        }
        transition={{
          duration: 0,
          ease: 'easeIn'
        }}
        id="path1701"
        style={{
          fill: '#131821',
          fillOpacity: 0.462745,
          strokeWidth: 0.264583
        }}
        d="M 1.1229292,0.37171037 C 0.50104621,0.37171037 2.1157018e-7,0.87223977 2.1157018e-7,1.4941225 V 136.94632 c 0,0.62188 0.50104599842982,1.12292 1.12292898842982,1.12292 H 375.30009 c 0.62189,0 1.12242,-0.50104 1.12242,-1.12292 V 1.4941225 c 0,-0.62188273 -0.50053,-1.12241213 -1.12242,-1.12241213 z M 214.92384,12.970425 h 13.93506 l 26.74152,97.134635 c 0,0 -0.82122,1.04773 -1.12292,1.12293 -12.75234,3.1805 -20.94174,3.2737 -31.45958,3.2737 -10.51783,0 -19.72912,-0.23896 -31.27303,-2.47892 -0.89946,-0.17453 -1.63315,-1.31101 -1.49655,-1.91771 z"
      />
    </svg>
  )
}
export default SvgComponent
